module.exports = __webpack_public_path__ + "static/img/aboutItem2.88236c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/aboutItem2.png
// module id = kJ7+
// module chunks = 0